import req from './request'

const DEFAULT_ENDPOINTS = {
    list: '/anti-fraud',
    config: '/anti-fraud/list-config',
    driverException: '/anti-fraud/driver-exception',
    setting: '/anti-fraud/setting',
    devices: '/anti-fraud/devices',
    comment: '/anti-fraud/comment',
    platform: "/anti-fraud/platform",
    holdOrderslist: '/fraud/hold-orders/list', // ?type={opened/closed},
    holdordersdetails: '/fraud/hold-orders/details',
    holdOrdersProcessing: '/fraud/hold-orders/processing'
    
}

export default {
    list(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.list, param)
    },
    config(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.config, param)
    },
    driverException(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.driverException, param)
    },
    setting(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.setting, param)
    },
    devices(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.devices, param)
    },
    comment(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.comment, param)
    },
    platform(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.platform, param)
    },
    holdOrderslist(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.holdOrderslist, param)
    },
    holdordersdetails(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.holdordersdetails, param)
    },
    holdOrdersProcessing(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.holdOrdersProcessing, param)
    },
}